import { Box, Button, Grid, Typography, MenuItem, TextField, Divider, Modal, Checkbox, Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomSelect from "../common/customSelectInput";
import DeleteIcon from '@mui/icons-material/Delete';
import { ArrowBackIos, HelpOutline } from "@mui/icons-material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const itemsModal = {
    borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 22px 165px 63px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}

const EditAdditionalServices = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const [successShow, setSuccessShow] = useState({ state: false, message: "" })
    const [errorShow, setErrorShow] = useState({ state: false, message: "" })
    const { serviceId } = useParams();
    const [services, setServices] = useState([]);
    const [serviceBoxes, setServiceBoxes] = useState([{ serviceName: '', cost: '' }]);
    const [serviceData, setServiceData] = useState({
        serviceName: '',
        selectionType: '',
        items: []
    });
    const navigate = useNavigate();

    const Services = () => {
        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/get_additional_services`
        }).then((data) => {
            const services = data.response?.data;
            const filteredData = services.find(item => item._id === serviceId);
            if (filteredData) {
                setServiceData({
                    serviceName: filteredData.serviceName,
                    selectionType: filteredData.selectionType,
                    items: filteredData.items || []
                });
                setServiceBoxes(filteredData.items);
            }
        }).catch((error) => {
        });
    }

    useEffect(() => {
        Services()
    }, [serviceId])

    const selectOptions = [
        { id: 1, label: 'Multiple', value: 'multiple' },
        { id: 2, label: 'Single', value: 'single' },
    ]

    const handleAddBox = () => {
        setServiceBoxes([...serviceBoxes, { serviceName: '', cost: '' }]);
    };
    const handleDeleteBox = (indexToRemove) => {
        setServiceBoxes(serviceBoxes.filter((_, index) => index !== indexToRemove));
    };

    const handleFormData = (e) => {
        setServiceData({ ...serviceData, [e.target.name]: e.target.value });
    }
    const handleServiceSubmit = () => {
        const isAnyEmpty = serviceBoxes.some(box => box.itemName === '' || box.itemPrice === '');
        if (isAnyEmpty) {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }
        if (serviceData.serviceName === '' || serviceData.selectionType === '') {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }
        const updatedServiceData = {
            ...serviceData,
            items: serviceBoxes.map((box) => ({
                itemName: box.itemName,
                itemPrice: box.itemPrice,
                isCustomizable: box?.isCustomizable
            }))
        };
        HttpRequest({
            method: 'POST',
            url: `/api/v1/ecommerce/edit_additional_services/${serviceId}`,
            body: updatedServiceData,
        }).then((data) => {
            if (data?.status === 200) {
                setSuccessShow({ state: true, message: "Service updated successfully" });
                setServiceData({
                    serviceName: '',
                    selectionType: '',
                    items: []
                });
                setServiceBoxes([{ serviceName: '', cost: '' }]);
                Services()
                setTimeout(() => {
                    navigate('/zed_ecommerce/additionalServices');
                }, 2000);
            } else {
                setErrorShow({ state: true, message: data.response?.data?.message });
            }
        }).catch((error) => {
            setErrorShow({ state: true, message: "Error updating service" });
        })
    }

    
    const breadcrumbs = [
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 3 : 3 }}>
            Dashboard
        </Typography>,
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
            Inventory
        </Typography>,
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
            Additional Services
        </Typography>,
        <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
            Edit Additional Services
        </Typography>
    ];

    return (
        <Box sx={{ mt: { xs: "15%", sm: "3.5%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 360px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3.5, sm: 0 } }}>
            <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
            <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                <Box sx={{ flexDirection: "column", flex: 1 }}>
                    <Box variant="h4" sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                        <Box mt={0.5}>
                        <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain' }} onClick={() => { navigate('/zed_ecommerce/additionalServices') }} />
                        </Box>
                        <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600"}}>
                            Edit Additional Services
                        </Typography>
                    </Box>
                    <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { xs: -3, sm: -3 } }}>
                    <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                        {breadcrumbs}
                    </Breadcrumbs>
                    </Grid>
                    <Box>
                        <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}>
                            Additional services allow your customers customise the final product before delivery.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
                    <Button variant="contained" sx={{ opacity: '0.9', backgroundColor: "#b4bcc4", color: "#707070", textTransform: "none", borderRadius: "4px", padding: { xs: "12.5px 20px", sm: "12.5px 37px 12.5px 38px" }, height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#b4bcc4", color: "#707070" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => navigate(-1)} >
                        <Typography sx={{ color: '#707070', fontWeight: '550', fontSize: { xs: "14px", sm: "16px" } }}>Cancel</Typography>
                    </Button>
                </Box>
            </Box>
            
            <Box sx={{ width: { xs: "100%", sm: "800px" }, marginTop: "20px" }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 1 } }}>
                    <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                        <CustomInputLabel label="Service Name" placeholder="Enter ServiceName Name" />
                        <TextField label="Service Name" value={serviceData?.serviceName} name="serviceName" onChange={handleFormData} sx={{ width: "100%" }} placeholder="Enter Service Name" size={isMobile ? "small" : "medium"}/>
                    </Box>
                    <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "0", sm: "-6px" } }}>
                        <CustomInputLabel label="Select Type" placeholder="Enter Select Type" />
                        <CustomSelect value={serviceData?.selectionType} name="selectionType" options={selectOptions} onChange={handleFormData} placeholder={"Select Type"} sm={"sm"} />
                    </Box>
                </Box>
                
                <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "20px" }, fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                    Service Items
                </Typography>
                
                {serviceBoxes?.map((box, index) => (
                    <Box key={index}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 1 } }}>
                            <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                                <CustomInputLabel label="Service Item Name" placeholder="Enter Service Name" />
                                <TextField value={box.itemName} name={`serviceName-${index}`} onChange={(e) => {
                                    const updatedBoxes = [...serviceBoxes];
                                    updatedBoxes[index].itemName = e.target.value;
                                    setServiceBoxes(updatedBoxes);
                                }} sx={{ width: "100%" }} placeholder="Service Name" size={isMobile ? "small" : "medium"}
                                />
                            </Box>
                            <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "0", sm: "" } }}>
                                <CustomInputLabel label="Cost" placeholder="Enter Cost" />
                                <TextField type="number" label="Service cost" value={box.itemPrice} name={`cost-${index}`} onChange={(e) => {
                                    const updatedBoxes = [...serviceBoxes];
                                    updatedBoxes[index].itemPrice = e.target.value;
                                    setServiceBoxes(updatedBoxes);
                                }} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: { xs: "flex-start", sm: "flex-end" }, alignItems: "end", marginTop: { xs: "0", sm: "20px" }, marginLeft: { xs: "0", sm: "20px" } }}>
                                <Typography variant="h4" sx={{ color: "#dc3545", fontSize: "30px", fontStyle: "normal", fontWeight: "600", marginTop: { xs: "10px", sm: "20px" }, cursor: 'pointer' }} onClick={() => handleDeleteBox(index)}>
                                    <DeleteIcon sx={{ fontSize: "30px" }} />
                                </Typography>
                            </Box>
                        </Box>
                        <Box style={{ display: "flex", alignItems: "center" }}>
                            <Checkbox style={{ color: "#b4bcc4", margin: '10px 6px 37px 0px' }} checked={box?.isCustomizable === true ? 'checked' : ''} value={box?.isCustomizable} onChange={(e) => {
                                const updatedBoxes = [...serviceBoxes];
                                updatedBoxes[index].isCustomizable = !box?.isCustomizable;
                                setServiceBoxes(updatedBoxes);
                            }} />
                            <Typography sx={{ margin: '20px 6px 37px 12px', fontSize: { xs: "14px", sm: "16px" }, color: '#707070', fontFamily: 'Poppins' }}>Customizable</Typography>
                            <HelpOutline sx={{ color: "#b4bcc4", margin: '20px 6px 37px 12px' }} />
                        </Box>
                    </Box>
                ))}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleAddBox}>
                        <AddCircleOutlineIcon sx={{ fontSize: { xs: "12px", sm: "14px" }, mr: 1 }} />   Add Another
                    </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: { xs: "center", sm: "flex-end" }, alignItems: "end", width: '100%' }}>
                    <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: { xs: "12.5px 30px", sm: "12.5px 48.7px 12.5px 49.3px" }, height: "45px", fontWeight: "600", marginTop: "20px", width: { xs: '100%', sm: 'auto' }}} onClick={handleServiceSubmit}>
                        Update
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default EditAdditionalServices